import configs from 'constants/configs';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { API_AUTH } from 'service/common';
import { Cookies } from "react-cookie";
class ThongBaoCapNhat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: '',
    };
  }
  componentDidMount() {
    let cookieName = 'IsThongBaoUser';
    let { id, getThongBao, updateThongBao, setShowThongBao } = this.props;
    if (this.getCookie(cookieName) !== 'True') {
      getThongBao({ id });
      updateThongBao({ id });
    } else {
      setShowThongBao();
    }
    this.setCookie(cookieName, 'True', 1);
  }
  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }
  getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  khongHienLai = (id) => () => {

    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }
    link = link + `taikhoan/ThongBao/KhongHienLai?id=${id}`;
    API_AUTH.get(link).then((res) => { });
  };
  render() {
    let props = this.props;
    let { thongbao, setShowThongBao } = props;
    let { objThongBao, isShowThongBao } = thongbao;
    let { Content, Title, showRead, NotificationId } = objThongBao;
    return (
      <Modal
        show={isShowThongBao}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i class="mdi mdi-alert"></i>
            </span>{' '}
            Thông báo
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={setShowThongBao}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="thongbao-capnhat">
            <h1 className="text-center">{Title}</h1>
            <div
              className="body-thongbaocapnhat"
              dangerouslySetInnerHTML={{ __html: Content }}
            ></div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          {showRead && (
            <fieldset className="checkboxsas">
              <label>
                <input
                  type="checkbox"
                  value=""
                  onChange={this.khongHienLai(NotificationId)}
                />{' '}
                Không hiện lại
              </label>
            </fieldset>
          )}

          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={setShowThongBao}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{' '}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ThongBaoCapNhat;
